import type { ApiError } from "@/types/api";

export function isApiError(error: unknown): error is { response: { data: ApiError } } {
  return (
    typeof error === 'object' &&
    error !== null &&
    'response' in error &&
    typeof (error as any).response.data === 'object' &&
    'errorCode' in (error as any).response.data
  );
}